import { createContext } from 'react';
import type { IRoute } from '../types/routes';
import type { ISidebarItem } from '../types/sidebar';

export interface IConfigContext {
  routes: IRoute[];
  sidebar: ISidebarItem[];
  sidebarCollapsed: boolean;
  onSidebarCollapse: (value: boolean) => void;
}

export const ConfigContext = createContext<IConfigContext>({
  routes: [],
  sidebar: [],
  sidebarCollapsed: false,
  onSidebarCollapse: () => {},
});

ConfigContext.displayName = 'ConfigContext';
